import React from 'react';
import { Target, Shield, TrendingUp, CheckCircle2, Award, Users } from 'lucide-react';

const ObjectiveSection = () => {
  const objectives = [
    {
      icon: Target,
      title: "Governança Operacional Ponta a Ponta",
      description: "Controle completo desde o cadastro até o embarque, com rastreabilidade total"
    },
    {
      icon: Shield,
      title: "Aumentar Segurança e Previsibilidade",
      description: "Eliminar acessos não autorizados e reduzir custos operacionais ocultos"
    },
    {
      icon: CheckCircle2,
      title: "Evidências Objetivas da Operação",
      description: "Dados concretos e relatórios completos para prestação de contas"
    },
    {
      icon: Users,
      title: "Melhorar Experiência do Condômino",
      description: "Mais transparência, informação em tempo real e facilidade de acesso"
    },
    {
      icon: Award,
      title: "Diferenciar no Mercado",
      description: "Tecnologia de ponta que posiciona a sua empresa de transporte entre os melhores da categoria"
    }
  ];

  return (
    <section id="objective" className="py-24 bg-gradient-to-br from-[#0f1a36] to-[#1a2847] relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 right-0 w-96 h-96 bg-[#007bff] rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-[#008080] rounded-full mix-blend-multiply filter blur-3xl opacity-10"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full border border-white/20 mb-6">
            <Target className="w-4 h-4 text-[#008080]" />
            <span className="text-sm font-medium text-white">Nossa Proposta</span>
          </div>
          
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
  Objetivo da Solução {" "}
  <span className="font-['Sora']">
    <span className="font-extrabold">WCOM</span>
    <span className="font-normal">Pass</span>
  </span>
</h2>

          <p className="text-xl text-gray-300">
            Transformar a gestão de transporte condominial com tecnologia, segurança e dados confiáveis
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-7xl mx-auto mb-16">
          {objectives.map((objective, index) => {
            const Icon = objective.icon;
            return (
              <div 
                key={index}
                className="group relative bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10 hover:border-[#007bff]/50 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-14 h-14 rounded-xl bg-[#007bff]/20 flex items-center justify-center mb-6 group-hover:scale-110 group-hover:bg-[#007bff]/30 transition-all duration-300">
                  <Icon className="w-7 h-7 text-[#007bff]" />
                </div>
                
                <h3 className="text-xl font-bold text-white mb-3">
                  {objective.title}
                </h3>
                
                <p className="text-gray-300 leading-relaxed">
                  {objective.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="bg-gradient-to-r from-[#007bff] to-[#0056b3] rounded-3xl p-12 shadow-2xl">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-shrink-0">
                <div className="w-24 h-24 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
                  <TrendingUp className="w-12 h-12 text-white" />
                </div>
              </div>
              
              <div className="text-white flex-grow">
                <h3 className="text-3xl font-bold mb-4">
                  Resultado Esperado
                </h3>
                <p className="text-xl text-white/90 leading-relaxed">
                  Com o WCOMPass, a <span className="font-bold">sua empresa de transportes</span> entregará mais que transporte: 
                  oferecerá <span className="font-bold">governança, segurança e valor agregado</span> para a 
                  seus clientes, diferenciando-se da concorrência e fortalecendo parcerias de longo prazo.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ObjectiveSection;
